import apiClient from '../../../../shared/api/apiClient'
import { ENDPOINTS } from '../../../../shared/api/endpoints'

export interface DropdownOption {
  label: string
  value: string
}

/**
 * Fetch dynamic departments from live API: GET /api/departments
 */
export async function fetchDepartmentFilterOptions(): Promise<DropdownOption[]> {
  try {
    const response = await apiClient.get<any>(ENDPOINTS.DEPARTMENTS.LIST)
    const payload = response.data
    const dataObj = payload?.data || payload
    const items: any[] = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.items)
      ? payload.items
      : Array.isArray(dataObj?.items)
      ? dataObj.items
      : Array.isArray(dataObj)
      ? dataObj
      : []

    const validOptions: DropdownOption[] = items
      .filter((dept) => Boolean(dept && (dept.departmentName || dept.name || dept.title)))
      .map((dept) => {
        const name = String(dept.departmentName || dept.name || dept.title).trim()
        const id = String(dept.id || dept.departmentId || dept._id || name).trim()
        return { label: name, value: id }
      })

    const unique = Array.from(new Map(validOptions.map((opt) => [opt.value, opt])).values())

    return [{ label: 'All Departments', value: '' }, ...unique]
  } catch (error) {
    console.warn('Failed to fetch departments for report filter dropdown:', error)
    return [{ label: 'All Departments', value: '' }]
  }
}

/**
 * Fetch dynamic organizational designations from live API: GET /api/designations
 */
export async function fetchDesignationFilterOptions(): Promise<DropdownOption[]> {
  try {
    const response = await apiClient.get<any>(ENDPOINTS.DESIGNATIONS.LIST, {
      params: { page: 1, limit: 100 },
    })
    const payload = response.data
    const dataObj = payload?.data || payload
    const items: any[] = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.items)
      ? payload.items
      : Array.isArray(dataObj?.items)
      ? dataObj.items
      : Array.isArray(dataObj)
      ? dataObj
      : []

    const validOptions: DropdownOption[] = items
      .filter((desig) => Boolean(desig && (desig.title || desig.name || desig.designationTitle)))
      .map((desig) => {
        const name = String(desig.title || desig.name || desig.designationTitle).trim()
        return { label: name, value: name }
      })

    const unique = Array.from(new Map(validOptions.map((opt) => [opt.value, opt])).values())

    return [{ label: 'All Designations', value: 'All Designations' }, ...unique]
  } catch (error) {
    console.warn('Failed to fetch designations for report filter dropdown:', error)
    return [{ label: 'All Designations', value: 'All Designations' }]
  }
}

/**
 * Fetch dynamic leave policies from live API: GET /api/hrms/leave/policies/dropdown
 */
export async function fetchLeavePolicyFilterOptions(): Promise<DropdownOption[]> {
  try {
    const response = await apiClient.get<any>(ENDPOINTS.HRMS.LEAVE_POLICIES_DROPDOWN)
    const payload = response.data
    const dataObj = payload?.data || payload
    const items: any[] = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.items)
      ? payload.items
      : Array.isArray(dataObj?.items)
      ? dataObj.items
      : Array.isArray(dataObj)
      ? dataObj
      : []

    const validOptions: DropdownOption[] = items
      .filter((pol) => Boolean(pol && (pol.name || pol.policyName || pol.title || pol.label)))
      .map((pol) => {
        const name = String(pol.name || pol.policyName || pol.title || pol.label).trim()
        return { label: name, value: name }
      })

    const unique = Array.from(new Map(validOptions.map((opt) => [opt.value, opt])).values())

    return [{ label: 'All Leave Types', value: 'All Leave Types' }, ...unique]
  } catch (error) {
    console.warn('Failed to fetch leave policies for report filter dropdown:', error)
    return [{ label: 'All Leave Types', value: 'All Leave Types' }]
  }
}
